import { render, staticRenderFns } from "./hiTags.vue?vue&type=template&id=c5dacab4&"
import script from "./hiTags.vue?vue&type=script&lang=js&"
export * from "./hiTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports